import axios from 'axios';

let isInterceptorSetup = false;

const setupAuthInterceptor = () => {
  if (isInterceptorSetup) return;

  axios.interceptors.response.use(
    (response) => {
      const anonToken = response.headers['x-anon-token'];
      if (anonToken) {
        localStorage.setItem('anonToken', anonToken);
        axios.defaults.headers.common['X-Anon-Token'] = anonToken;
      }
      return response;
    },
    (error) => {
      if (error.response?.status === 401 && error.response?.data?.detail === "Could not validate credentials") {
        removeToken();
      }
      return Promise.reject(error);
    }
  );

  isInterceptorSetup = true;
};

export const initializeAuth = () => {
  setupAuthInterceptor();
  const token = localStorage.getItem('token');
  if (token) {
    axios.defaults.headers.common['X-Auth-Token'] = token;
  } else {
    const anonToken = localStorage.getItem('anonToken');
    if (anonToken) {
      axios.defaults.headers.common['X-Anon-Token'] = anonToken;
    }
  }
};

export const setToken = (token) => {
  localStorage.setItem('token', token);
  axios.defaults.headers.common['X-Auth-Token'] = token;
  // JWT takes over — anon token no longer needed in headers
  delete axios.defaults.headers.common['X-Anon-Token'];
};

export const getToken = () => localStorage.getItem('token');
export const getAnonToken = () => localStorage.getItem('anonToken');

export const removeToken = () => {
  localStorage.removeItem('token');
  delete axios.defaults.headers.common['X-Auth-Token'];
  // Restore anon token header after logout
  const anonToken = localStorage.getItem('anonToken');
  if (anonToken) {
    axios.defaults.headers.common['X-Anon-Token'] = anonToken;
  }
};
